<template>
  <section id="home" class="hero">
    <div class="hero-background">
      <div class="grid-overlay"></div>
      <div class="floating-elements">
        <div class="floating-circle" v-for="i in 6" :key="i" :style="{ animationDelay: `${i * 0.5}s` }"></div>
      </div>
    </div>
    
         <div class="hero-container">
       <div class="hero-content">
         <div class="hero-badge">
           <span class="badge-icon">🚀</span>
           <span>智能通讯录管理平台</span>
         </div>

         <h1 class="hero-title">
           <span class="title-line">企业通讯录</span>
           <span class="title-subtitle">连接全产业链的商务解决方案</span>
         </h1>

         <p class="hero-description">
           专业的企业通讯录管理平台，为您提供全方位的联系人管理、产业链对接、商务沟通等服务，助力企业发展。
         </p>

         <div class="hero-features">
           <div class="feature-item">
             <div class="feature-icon">⚡</div>
             <span>快速查找</span>
           </div>
           <div class="feature-item">
             <div class="feature-icon">🔗</div>
             <span>产业链对接</span>
           </div>
           <div class="feature-item">
             <div class="feature-icon">🛡️</div>
             <span>数据安全</span>
           </div>
         </div>
         
         <div class="hero-actions">
           <button class="btn btn-primary">
             <span class="btn-icon">📱</span>
             <span>立即下载</span>
             <div class="btn-glow"></div>
           </button>
           <button class="btn btn-secondary">
             <span class="btn-icon">🎥</span>
             <span>观看演示</span>
           </button>
         </div>
         
         <div class="hero-stats">
           <div class="stat-item">
             <div class="stat-number">50万+</div>
             <div class="stat-label">注册用户</div>
           </div>
           <div class="stat-item">
             <div class="stat-number">10万+</div>
             <div class="stat-label">企业资源</div>
           </div>
           <div class="stat-item">
             <div class="stat-number">99%</div>
             <div class="stat-label">用户好评</div>
           </div>
         </div>
       </div>
       
       <div class="hero-visual">
         <div class="tech-cube">
           <div class="cube-face cube-front">
             <div class="cube-content">
               <div class="data-flow">
                 <div class="data-line" v-for="i in 5" :key="i" :style="{ animationDelay: `${i * 0.2}s` }"></div>
               </div>
               <div class="connection-nodes">
                 <div class="node" v-for="i in 8" :key="i" :style="{ animationDelay: `${i * 0.3}s` }"></div>
               </div>
             </div>
           </div>
           <div class="cube-face cube-back"></div>
           <div class="cube-face cube-right"></div>
           <div class="cube-face cube-left"></div>
           <div class="cube-face cube-top"></div>
           <div class="cube-face cube-bottom"></div>
         </div>
         
         <div class="floating-elements-3d">
           <div class="hologram-circle" v-for="i in 3" :key="i" :style="{ animationDelay: `${i * 0.5}s` }"></div>
           <div class="energy-particles" v-for="i in 12" :key="i" :style="{ animationDelay: `${i * 0.1}s` }"></div>
         </div>
         
         <div class="tech-grid">
           <div class="grid-line" v-for="i in 20" :key="i" :style="{ animationDelay: `${i * 0.05}s` }"></div>
         </div>
       </div>
     </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  data() {
    return {
      contacts: [
        { name: '张经理', company: '科技公司', initial: '张', color: '#00d4ff' },
        { name: '李总监', company: '制造企业', initial: '李', color: '#ff6b6b' },
        { name: '王工程师', company: '软件开发', initial: '王', color: '#4ecdc4' },
        { name: '陈设计师', company: '创意工作室', initial: '陈', color: '#45b7d1' }
      ]
    }
  }
}
</script>

<style scoped>
.hero {
  min-height: 100vh;
  background: linear-gradient(135deg, #0a0e17 0%, #1a1f2e 50%, #0a0e17 100%);
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.grid-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(0, 212, 255, 0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 212, 255, 0.1) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

.floating-elements {
  position: absolute;
  width: 100%;
  height: 100%;
}

.floating-circle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: #00d4ff;
  border-radius: 50%;
  box-shadow: 0 0 10px #00d4ff;
  animation: float 6s ease-in-out infinite;
}

.floating-circle:nth-child(1) { top: 20%; left: 10%; }
.floating-circle:nth-child(2) { top: 60%; left: 80%; }
.floating-circle:nth-child(3) { top: 80%; left: 20%; }
.floating-circle:nth-child(4) { top: 30%; left: 70%; }
.floating-circle:nth-child(5) { top: 70%; left: 30%; }
.floating-circle:nth-child(6) { top: 40%; left: 60%; }

  .hero-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 60px;
    align-items: center;
    position: relative;
    z-index: 2;
  }

.hero-content {
  color: #ffffff;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(0, 212, 255, 0.1);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 0.9rem;
  margin-bottom: 24px;
  backdrop-filter: blur(10px);
}

.badge-icon {
  font-size: 1rem;
}

.hero-title {
  margin-bottom: 24px;
}

.title-line {
  display: block;
  font-size: 3.5rem;
  font-weight: 800;
  background: linear-gradient(45deg, #00d4ff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.1;
  margin-bottom: 12px;
}

.title-subtitle {
  display: block;
  font-size: 1.5rem;
  color: #8892b0;
  font-weight: 400;
}

.hero-description {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #a0aec0;
  margin-bottom: 32px;
  max-width: 500px;
}

.hero-features {
  display: flex;
  gap: 24px;
  margin-bottom: 40px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #8892b0;
}

.feature-icon {
  font-size: 1.1rem;
}

.hero-actions {
  display: flex;
  gap: 16px;
  margin-bottom: 48px;
}

.btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 32px;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.btn-primary {
  background: linear-gradient(45deg, #00d4ff, #0099cc);
  color: #ffffff;
  box-shadow: 0 8px 32px rgba(0, 212, 255, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 212, 255, 0.4);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: translateY(-2px);
}

.btn-glow {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.btn-primary:hover .btn-glow {
  left: 100%;
}

.hero-stats {
  display: flex;
  gap: 40px;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: #00d4ff;
  margin-bottom: 4px;
}

  .stat-label {
    font-size: 0.9rem;
    color: #8892b0;
  }

  /* 3D科技区域样式 */
  .hero-visual {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    perspective: 1000px;
  }

  .tech-cube {
    width: 200px;
    height: 200px;
    position: relative;
    transform-style: preserve-3d;
    animation: cubeRotate 20s linear infinite;
  }

  .cube-face {
    position: absolute;
    width: 200px;
    height: 200px;
    background: rgba(0, 212, 255, 0.1);
    border: 2px solid rgba(0, 212, 255, 0.3);
    backdrop-filter: blur(10px);
  }

  .cube-front {
    transform: translateZ(100px);
  }

  .cube-back {
    transform: translateZ(-100px) rotateY(180deg);
  }

  .cube-right {
    transform: translateX(100px) rotateY(90deg);
  }

  .cube-left {
    transform: translateX(-100px) rotateY(-90deg);
  }

  .cube-top {
    transform: translateY(-100px) rotateX(90deg);
  }

  .cube-bottom {
    transform: translateY(100px) rotateX(-90deg);
  }

  .cube-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .data-flow {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .data-line {
    position: absolute;
    width: 2px;
    height: 60px;
    background: linear-gradient(to bottom, transparent, #00d4ff, transparent);
    animation: dataFlow 3s ease-in-out infinite;
  }

  .data-line:nth-child(1) { left: 20%; top: -30px; }
  .data-line:nth-child(2) { left: 40%; top: -30px; }
  .data-line:nth-child(3) { left: 60%; top: -30px; }
  .data-line:nth-child(4) { left: 80%; top: -30px; }
  .data-line:nth-child(5) { left: 50%; top: -30px; }

  .connection-nodes {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .node {
    position: absolute;
    width: 8px;
    height: 8px;
    background: #00d4ff;
    border-radius: 50%;
    box-shadow: 0 0 10px #00d4ff;
    animation: nodePulse 2s ease-in-out infinite;
  }

  .node:nth-child(1) { top: 20%; left: 20%; }
  .node:nth-child(2) { top: 20%; right: 20%; }
  .node:nth-child(3) { bottom: 20%; left: 20%; }
  .node:nth-child(4) { bottom: 20%; right: 20%; }
  .node:nth-child(5) { top: 50%; left: 10%; }
  .node:nth-child(6) { top: 50%; right: 10%; }
  .node:nth-child(7) { left: 50%; top: 10%; }
  .node:nth-child(8) { left: 50%; bottom: 10%; }

  .floating-elements-3d {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .hologram-circle {
    position: absolute;
    width: 120px;
    height: 120px;
    border: 2px solid rgba(0, 212, 255, 0.3);
    border-radius: 50%;
    animation: hologramRotate 8s linear infinite;
  }

  .hologram-circle:nth-child(1) { top: -60px; left: -60px; }
  .hologram-circle:nth-child(2) { top: -60px; right: -60px; }
  .hologram-circle:nth-child(3) { bottom: -60px; left: 50%; transform: translateX(-50%); }

  .energy-particles {
    position: absolute;
    width: 4px;
    height: 4px;
    background: #00d4ff;
    border-radius: 50%;
    box-shadow: 0 0 8px #00d4ff;
    animation: particleFloat 4s ease-in-out infinite;
  }

  .energy-particles:nth-child(4) { top: 10%; left: 10%; }
  .energy-particles:nth-child(5) { top: 15%; right: 15%; }
  .energy-particles:nth-child(6) { bottom: 10%; left: 15%; }
  .energy-particles:nth-child(7) { bottom: 15%; right: 10%; }
  .energy-particles:nth-child(8) { top: 30%; left: 5%; }
  .energy-particles:nth-child(9) { top: 35%; right: 5%; }
  .energy-particles:nth-child(10) { bottom: 30%; left: 5%; }
  .energy-particles:nth-child(11) { bottom: 35%; right: 5%; }
  .energy-particles:nth-child(12) { top: 50%; left: 20%; }
  .energy-particles:nth-child(13) { top: 55%; right: 20%; }
  .energy-particles:nth-child(14) { bottom: 50%; left: 20%; }
  .energy-particles:nth-child(15) { bottom: 55%; right: 20%; }

  .tech-grid {
    position: absolute;
    width: 300px;
    height: 300px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .grid-line {
    position: absolute;
    background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.2), transparent);
    animation: gridScan 2s ease-in-out infinite;
  }

  .grid-line:nth-child(odd) {
    width: 100%;
    height: 1px;
    top: calc(var(--i, 0) * 15px);
  }

  .grid-line:nth-child(even) {
    width: 1px;
    height: 100%;
    left: calc(var(--i, 0) * 15px);
  }



@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

 @keyframes float {
   0%, 100% {
     transform: translateY(0px);
     opacity: 0.7;
   }
   50% {
     transform: translateY(-20px);
     opacity: 1;
   }
 }

 @keyframes cubeRotate {
   0% {
     transform: rotateX(0deg) rotateY(0deg);
   }
   100% {
     transform: rotateX(360deg) rotateY(360deg);
   }
 }

 @keyframes dataFlow {
   0% {
     transform: translateY(-60px);
     opacity: 0;
   }
   50% {
     opacity: 1;
   }
   100% {
     transform: translateY(60px);
     opacity: 0;
   }
 }

 @keyframes nodePulse {
   0%, 100% {
     transform: scale(1);
     opacity: 0.7;
   }
   50% {
     transform: scale(1.5);
     opacity: 1;
   }
 }

 @keyframes hologramRotate {
   0% {
     transform: rotate(0deg);
   }
   100% {
     transform: rotate(360deg);
   }
 }

 @keyframes particleFloat {
   0%, 100% {
     transform: translateY(0px) translateX(0px);
     opacity: 0.5;
   }
   25% {
     transform: translateY(-10px) translateX(5px);
     opacity: 1;
   }
   50% {
     transform: translateY(-5px) translateX(-5px);
     opacity: 0.8;
   }
   75% {
     transform: translateY(5px) translateX(10px);
     opacity: 1;
   }
 }

 @keyframes gridScan {
   0% {
     opacity: 0;
     transform: scaleX(0);
   }
   50% {
     opacity: 1;
     transform: scaleX(1);
   }
   100% {
     opacity: 0;
     transform: scaleX(0);
   }
 }

     @media (max-width: 768px) {
     .hero-container {
       grid-template-columns: 1fr;
       text-align: center;
       gap: 40px;
     }
     
     .title-line {
       font-size: 2.5rem;
     }
     
     .title-subtitle {
       font-size: 1.2rem;
     }
     
     .hero-features {
       justify-content: center;
       flex-wrap: wrap;
     }
     
     .hero-actions {
       flex-direction: column;
       align-items: center;
     }
     
     .btn {
       width: 100%;
       max-width: 280px;
       justify-content: center;
     }
     
     .hero-stats {
       justify-content: center;
     }

     .tech-cube {
       width: 150px;
       height: 150px;
     }

     .cube-face {
       width: 150px;
       height: 150px;
     }

     .cube-front {
       transform: translateZ(75px);
     }

     .cube-back {
       transform: translateZ(-75px) rotateY(180deg);
     }

     .cube-right {
       transform: translateX(75px) rotateY(90deg);
     }

     .cube-left {
       transform: translateX(-75px) rotateY(-90deg);
     }

     .cube-top {
       transform: translateY(-75px) rotateX(90deg);
     }

     .cube-bottom {
       transform: translateY(75px) rotateX(-90deg);
     }

     .hologram-circle {
       width: 80px;
       height: 80px;
     }

     .hologram-circle:nth-child(1) { top: -40px; left: -40px; }
     .hologram-circle:nth-child(2) { top: -40px; right: -40px; }
     .hologram-circle:nth-child(3) { bottom: -40px; left: 50%; transform: translateX(-50%); }

     .tech-grid {
       width: 200px;
       height: 200px;
     }
   }
</style>
